/* eslint-disable complexity */
import React, { useState } from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import styles from "./styles.css";
import { TAB_NAMES } from "../post-inspection-diy-header-v2/constant";

const PostInspectionDiyBankAccountInfo = loadable(() => import("../post-inspection-diy-bank-account-info"));
const PostInspectionDiyBankAccountThirdParty = loadable(() => import("../post-inspection-diy-bank-account-third-party"));

// eslint-disable-next-line max-statements
const PostInspectionDiyBankAccount = ({
    inspectionResponse,
    postTokenDocuments,
    setIsBankVerificationFailed = () => {},
    diyPaymentApprovalProcessConnect,
    setActiveTabConnect = () => {}
}) => {
    const { token } = inspectionResponse || {};
    const {
        bank: bankDetails
    } = postTokenDocuments || {};

    const [showFetchedAccountDetails, setShowFetchedAccountDetails] = useState(false);

    const closeAll = () => {
        setShowFetchedAccountDetails(false);
        setActiveTabConnect(TAB_NAMES.DOCUMENTATION);
    };

    const fetchInspectionAfterBankVerification = (closeModal = true) => {
        diyPaymentApprovalProcessConnect(token);
        if (closeModal) {
            setIsBankVerificationFailed(false);
            closeAll();
        }
    };

    const onRetryClick = () => {
        setShowFetchedAccountDetails(false);
    };

    const openBankDetails = () => {
        setShowFetchedAccountDetails(true);
    };

    return (
        <React.Fragment>
            <div styleName={"styles.modalWrapper"}>
                {
                    showFetchedAccountDetails ?
                        <PostInspectionDiyBankAccountThirdParty
                            bankDetails={bankDetails}
                            onRetryClick={onRetryClick}
                            fetchInspectionAfterBankVerification={fetchInspectionAfterBankVerification}
                        /> :
                        <PostInspectionDiyBankAccountInfo
                            bankDetails={bankDetails}
                            fetchInspectionAfterBankVerification={fetchInspectionAfterBankVerification}
                            openBankDetails={openBankDetails}
                        />
                }
            </div>
        </React.Fragment>
    );
};

PostInspectionDiyBankAccount.propTypes = {
    inspectionResponse: PropTypes.object,
    postTokenDocuments: PropTypes.object,
    setIsBankVerificationFailed: PropTypes.func,
    diyPaymentApprovalProcessConnect: PropTypes.func,
    setActiveTabConnect: PropTypes.func
};

export default PostInspectionDiyBankAccount;

